import { render, staticRenderFns } from "./mind-map.vue?vue&type=template&id=f04a3946&scoped=true"
import script from "./mind-map.vue?vue&type=script&lang=js"
export * from "./mind-map.vue?vue&type=script&lang=js"
import style0 from "./mind-map.vue?vue&type=style&index=0&id=f04a3946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04a3946",
  null
  
)

export default component.exports